import * as React from 'react'
import { OptionComponentProps } from 'react-select'

import Icon from 'components/Icon'
import { UI } from 'Icon/ui'

interface CheckboxOptionProps {
  children?: React.ReactNode | undefined
}

class CheckboxOption extends React.Component<CheckboxOptionProps & OptionComponentProps, {}> {
  constructor(props: OptionComponentProps) {
    super(props)
    this.handleMouseDown = this.handleMouseDown.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this)
  }

  public handleMouseDown(event: any) {
    event.preventDefault()
    event.stopPropagation()
    if (this.props.onSelect) {
      this.props.onSelect(this.props.option, event)
    }
  }

  public handleMouseEnter(event: any) {
    if (this.props.onFocus) {
      this.props.onFocus(this.props.option, event)
    }
  }

  public handleMouseMove(event: any) {
    if (this.props.isFocused) {
      return
    }
    if (this.props.onFocus) {
      this.props.onFocus(this.props.option, event)
    }
  }

  public render() {
    return (
      <li
        className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}
      >
        <label>
          <Icon icon={UI.check} />
          {this.props.children}
        </label>
      </li>
    )
  }
}

export default CheckboxOption
